import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IVehiclesParams, IVehiclesResponse, IVehiclesState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchListVehicles = createAsyncThunk(
  'listVehicles/fetchListVehicles',
  async ({ query }: IVehiclesParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.getVehicles(query)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IVehiclesState = {
  isLoading: false,
  response: null,
  error: null
}

const listVehiclesSlice = createSlice({
  name: 'models/list',
  initialState,
  reducers: {
    resetListModels: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchListVehicles.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchListVehicles.fulfilled, (state, action: PayloadAction<IVehiclesResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchListVehicles.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default listVehiclesSlice.reducer
export const { resetListModels } = listVehiclesSlice.actions
